import { loadGoogleMaps } from "./lib";
import { APP_LOGGER } from "@/app/logger";

loadGoogleMaps()
    .catch(error => APP_LOGGER.error("Unexpected error while loading Google Maps library", { error }));
